import React from "react";
import { Modal, Table, Button } from "react-bootstrap";
import obj, { formatDate, toFixedWithoutRounding } from "../../utils/constants";

export default function ParlayModal({ isOpen, onClose, data }) {
  return (
    <Modal className="exposure_modal" size="lg" show={isOpen} onHide={onClose}>
      <Modal.Body className="p-0">
        <div className="exposure-content">
          <h2>List Bets</h2>
          <div className="responsive">
            <Table>
              <thead>
                <tr>
                  <th scope="col">Sport</th>
                  <th scope="col">Event</th>
                  <th scope="col">Market</th>
                  <th scope="col">selName</th>
                  <th scope="col">Bet taken</th>
                  <th scope="col">Type</th>
                  <th scope="col">Odds</th>
                  <th scope="col">Result</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={item?._id || index}>
                      <td>{obj?.betCheckObj[item?.eventType]}</td>
                      <td>
                        {obj?.betCheckObj[item?.eventType]}
                        <span className="angle_unicode"> ▸ </span>
                        {item?.matchName}
                      </td>
                      <td>{item?.fancyName}</td>
                      <td>{item?.runnerName}</td>
                      <td>{formatDate(item?.timeInserted)}</td>
                      <td>Back</td>
                      <td>{toFixedWithoutRounding(item?.bhav)}</td>
                      <td>
                        {item?.isDeclared ? (
                          <span className={item?.result === "loss" ? "text-danger" : "text-success"}>
                            {item?.result === "loss"
                              ? `-${toFixedWithoutRounding(item?.loseAmount)}`
                              : toFixedWithoutRounding(item?.profitAmount)}
                          </span>
                        ) : (
                          <span>...</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8}>No Records Found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="secondary" onClick={onClose} className="theme_dark_btn">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}